import type { BeforeInstallPromptEvent } from '@/constants';
import { track } from '@shared/events';

/**
 * Shows the browser's install prompt and tracks what the reader chose.
 *
 * Every call site used to fire `deferredPrompt.prompt()` and never read
 * `userChoice`, so installs were counted (`INSTALLED`) but a prompt the reader
 * dismissed left no trace -- install conversion couldn't be measured. All five
 * places that open the prompt go through here, so the outcome is tracked once.
 *
 * Not wrapped in a try/catch on purpose: a `BeforeInstallPromptEvent` can only
 * be prompted once, and a second `prompt()` rejecting should still surface
 * through the global error capture exactly as it did before this existed.
 */
export async function promptInstall(
	deferredPrompt: BeforeInstallPromptEvent,
): Promise<void> {
	await deferredPrompt.prompt();
	const { outcome } = await deferredPrompt.userChoice;
	track('install_prompt_result', { outcome });
}
